import { useEffect } from 'react';

// Option Chain / Backtester: the table box scrolls on its own (filling the window below the
// page header and buttons), and the first two header rows stay at the top of it.
// `bottomReserve` = space kept free at the bottom (e.g. the Backtester playback bar).
export default function useStickyTableHeader(boxRef, firstRowRef, bottomReserve = 0) {
  useEffect(() => {
    const box = boxRef.current;
    if (!box) return undefined;
    // Applied on the next frame and only when a value changed, so resizing never feeds
    // back into the observer ("ResizeObserver loop completed with undelivered notifications").
    let frame = 0;
    const apply = () => {
      frame = 0;
      const top = box.getBoundingClientRect().top + window.scrollY;
      const boxH = `${Math.max(320, Math.round(window.innerHeight - top - bottomReserve))}px`;
      if (box.style.getPropertyValue('--oc-box-h') !== boxH) box.style.setProperty('--oc-box-h', boxH);
      const row = firstRowRef.current;
      const rowH = row ? `${row.offsetHeight}px` : null;
      if (rowH && box.style.getPropertyValue('--oc-row1-h') !== rowH) box.style.setProperty('--oc-row1-h', rowH);
    };
    const update = () => { if (!frame) frame = requestAnimationFrame(apply); };
    apply();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    if (ro) {
      ro.observe(document.body);
      if (firstRowRef.current) ro.observe(firstRowRef.current);
    }
    window.addEventListener('resize', update);
    return () => {
      if (frame) cancelAnimationFrame(frame);
      if (ro) ro.disconnect();
      window.removeEventListener('resize', update);
    };
  });
}
